import { TextField } from '@components/base/inputs';
import { VStack } from '@components/base/layout';

interface FailWorkflowConfigPanelProps {
  readonly getValue: (field: string) => unknown;
  readonly setValue: (field: string, value: unknown) => void;
}

/**
 * Config panel for the `fail-workflow` step type — its config is exactly
 * `{ message: string }`. When the step runs, the workflow halts and the
 * execute endpoint answers 422 with `message` as the error text.
 */
export function FailWorkflowConfigPanel({
  getValue,
  setValue,
}: Readonly<FailWorkflowConfigPanelProps>) {
  return (
    <VStack gap={4}>
      <TextField
        label="Message"
        required
        placeholder="e.g. Duplicate found: {{erp_response.data.0.DOUBLON}}"
        helperText="Error message the workflow fails with. Use {{context.path}} for dynamic values from the workflow context. Whether this step runs is controlled by the step's Condition."
        value={(getValue('config_message') as string | undefined) ?? ''}
        onChange={(e) => {
          setValue('config_message', e.target.value);
        }}
      />
    </VStack>
  );
}
